export default class FiltroGerarMovimento {
  constructor(entidadeId = null, anoReferencia = null, mesReferencia = null) {
    this.entidadeId = entidadeId
    this.anoReferencia = anoReferencia
    this.mesReferencia = mesReferencia
  }
}
